import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { motion } from 'framer-motion';

const NewUserChatbotPromo = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <motion.div
      className="fixed top-20 left-12 z-50 flex items-center pointer-events-auto"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.8, duration: 0.5 }}
    >
      {/* Big Bright Arrow */}
      <motion.div
        animate={{
          scale: [1, 1.1, 1],
          y: [-5, 5, -5],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <LucideIcons.ArrowUpLeft
          size={60}
          className="text-yellow-400 drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]"
        />
      </motion.div>
      {/* Persuasive Text Bubble */}
      <div className="bg-white text-gray-800 p-4 rounded-lg shadow-xl ml-2 relative">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-1 right-1 text-gray-500 hover:text-gray-800"
          aria-label="Close promo"
        >
          <LucideIcons.X size={16} />
        </button>
        <p className="font-bold text-lg pr-4">New to the cosmos?</p>
        <p>Ask our AI anything about the app!</p>
        {/* Triangle pointing to the button */}
        <div className="absolute right-full top-1/2 -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-r-8 border-r-white"></div>
      </div>
    </motion.div>
  );
};

export default NewUserChatbotPromo;
